<div class="container-fluid main-page settings questions">
    <div class="settings-sub-header w-100 px-4 pt-5 pb-4 border-0 bg-white">
        <div class="d-md-flex justify-content-between">
            <h3 class="">
                {{'polls_settings'| translate}}
                <small class="d-block text-secondary pt-2 ps-0">
                    {{'polls_settings.subtitle' | translate}}
                </small>
            </h3>
            
            <div class="d-flex align-items-md-center justify-content-center mt-3 mt-md-0">
                <button [matMenuTriggerFor]="createPollMenu" data-cy="createPoll"
                        type="button" class="btn btn-primary px-3 mb-1 align-top btn-menu">
                        {{'polls_settings.new' | translate}}...
                        <i class="fa-solid fa-chevron-down"></i>
                </button>
                <mat-menu #createPollMenu="matMenu">
                    <button mat-menu-item (click)="createPoll(null)" 
                            data-cy="createPollFromScratch">{{'polls_settings.new_from_scratch' | translate}}</button>
                    <button mat-menu-item (click)="goToTemplateBank()"
                            data-cy="createPollFromTemplate">{{'polls_settings.new_from_template' | translate}}</button>
                </mat-menu>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-md-7">
                <div class="input-group">
                    <input type="text" name="templateSearch" id="templateSearch" class="form-control mb-1" 
                           [formControl]='searchCtrl'
                           placeholder="{{ 'polls_settings.bank.search' | translate}}">
                    <span class="icon-addon">
                        @if(search_terms){
                            <i class="far fa-times" (click)="clear_search()"></i>
                        }
                        @else {
                            <i class="far fa-search"></i>
                        }
                    </span>
                </div>
            </div> 
        </div>
    </div>

    <div class="container-fluid px-0">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" 
                       [selectedIndex]="selectedTabIndex"
                       (selectedTabChange)="onTabChanged($event);">
            <mat-tab label="{{'polls_settings.questions' | translate}}" 
                     [disabled]="disableYourPollsTab" data-cy="userPollsTabs">
                @if(polls && polls.length > 0){
                    <div class="px-md-4 container-fluid container-fluid-limited" data-cy="userPolls">
                        <user-polls [polls]="filteredPolls"
                                    [searchTerm]="search_terms"
                                    (deletePoll)="deletePoll($event)"
                                    (reloadPolls)="refreshPolls($event)"></user-polls>
                    </div>
                }
            </mat-tab>
            <mat-tab label="{{'polls_settings.templates' | translate}}">
                <div class="px-md-4 container-fluid container-fluid-limited" data-cy="pollTemplates">
                    <poll-templates [searchTerm]="search_terms"
                                    [teams]="teams"
                                    (onPostNowPoll)="openPostNowDialog($event)"
                                    (onSelectTemplate)="createPoll($event)"></poll-templates>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    
</div>
